import sliderLoader from '../utils/slider-loader';

const Sliders = () => {
  const sharedSettings = {
    lazyLoad: 'progressive',
    autoplaySpeed: 3000,
    pauseOnFocus: true,
    pauseOnHover: true,
    swipeToSlide: true,
    slidesToShow: 4,
    autoplay: true,
    arrows: true,
    dots: false,
    rows: 0
  };
  /**
   *
   */
  sliderLoader({
    slider: '.online__carousel',
    settings: {
      ...sharedSettings,
      slidesToShow: 1
    }
  });
  /**
   * Exclusively articles slider. Big card with .bg-wild-sand
   */
  sliderLoader({
    slider: '.articles__carousel .cards-slider',
    settings: {
      ...sharedSettings,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 670,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: true
          }
        }
      ]
    }
  });
  /**
   * Full width sliders in sections with a container.
   */
  sliderLoader({
    slider: '.container__carousel .cards-slider',
    settings: {
      ...sharedSettings,
      responsive: [
        {
          settings: { dots: true, arrows: false },
          breakpoint: 1200
        },
        {
          settings: { dots: true, arrows: false, slidesToShow: 3 },
          breakpoint: 991
        },
        {
          settings: { dots: true, arrows: false, slidesToShow: 2 },
          breakpoint: 767
        },
        {
          settings: { dots: true, arrows: false, slidesToShow: 1 },
          breakpoint: 575
        }
      ]
    }
  });
};

export default Sliders;



// WEBPACK FOOTER //
// ./vively/scripts/components/sliders.js